<template>
  <section
    id="profile"
    class=""
  >
    <div class="profile-detail tw-bg-gradient-profile tw-pb-16 tw-pt-8 md:tw-pt-16">
      <div class="ns-container tw-flex tw-flex-col md:tw-flex-row tw-justify-start tw-relative">
        <div class="profile-picture-col tw-flex tw-flex-row md:tw-flex-col tw-flex-none tw-items-start md:tw-items-center">
          <div>
            <img
              v-if="data.profile.mainPicture.id"
              class="tw-rounded-full tw-border-8 tw-border-custom-midgray tw-object-cover"
              :src="thumb"
            >
          </div>
          <div class="tw-block md:tw-hidden tw-text-white tw-my-auto sm:tw-my-0 sm:tw-mt-10 tw-ml-5 tw-flex-shrink-0 tw-mx-5">
            <div class="tw-flex tw-items-center tw-text-2xl">
              <h2 class="tw-font-bold">
                {{ data.profile.nickname }}, {{ data.profile.age }}
              </h2>
              <i
                class="tw-ml-3 last-online-icon"
                :class="lastOnlineIcon"
                data-toggle="tooltip"
                :title="lastOnline"
              />
            </div>
            <h5 class="tw-text">
              {{ data.profile.profession }}
            </h5>
          </div>
        </div>
        <div class="profile-info-col font-fira tw-text-white tw-w-full tw-pl-5 lg:tw-px-20 tw-mt-5 md:tw-mt-16">
          <div class="tw-hidden md:tw-block">
            <div class="tw-flex tw-items-center tw-text-3xl">
              <h2 class="tw-font-bold">
                {{ data.profile.nickname }}, {{ data.profile.age }}
              </h2>
              <i
                class="tw-ml-3 last-online-icon"
                :class="lastOnlineIcon"
                data-toggle="tooltip"
                :title="lastOnline"
              />
            </div>
            <h5 class="tw-text-lg">
              {{ data.profile.profession }}
            </h5>
          </div>
          <div v-if="!isOwnProfile">
            <ProfileButtons :data="data" />
          </div>
          <hr class="tw-mt-4 tw-mb-10">
          <div class="">
            <div class="tw-flex">
              <template v-if="data.currentLocation">
                <span class="tw-w-1/3 md:tw-w-36 lg:tw-w-48 tw-flex-shrink-0">Currently in</span>
                <span class="tw-font-bold">{{ data.currentLocation.city }}, {{ data.currentLocation.country }}</span>
              </template>
              <button
                v-if="isOwnProfile"
                class="tw-ml-2 btn btn-xs btn-white"
                @click="refreshLocation"
              >
                Refresh
              </button>
            </div>
            <div class="tw-flex tw-justify-between md:tw-justify-start">
              <span class="tw-w-1/3 md:tw-w-36 lg:tw-w-48 tw-flex-shrink-0">Looking for</span>
              <span class="tw-w-1/2 md:tw-w-auto tw-font-bold tw-flex-grow">{{ lookingFor }}</span>
            </div>
            <div class="tw-flex tw-justify-between md:tw-justify-start">
              <span class="tw-w-1/3 md:tw-w-36 lg:tw-w-48 tw-flex-shrink-0">Interested In</span>
              <span class="tw-w-1/2 md:tw-w-auto tw-font-bold tw-flex-grow">{{ interestedIn }}</span>
            </div>
            <template v-if="data.profile.interests.length > 0">
              <div class="tw-flex tw-justify-between md:tw-justify-start">
                <div class="tw-w-1/3 md:tw-w-36 lg:tw-w-48 tw-flex-shrink-0">
                  Interests
                </div>
                <div class="tw-w-1/2 md:tw-w-auto tw-font-bold tw-flex-grow">
                  <span
                    v-for="(interest, interestIndex) in data.profile.interests"
                    :key="`interest-${interestIndex}`"
                    class="tw-cursor-pointer tw-text-sm tw-font-medium tw-text-custom-teal tw-bg-white tw-px-2 tw-mr-1 tw-mb-1 tw-rounded tw-align-middle tw-inline-block tw-whitespace-no-wrap"
                  >
                    {{ interest.name }}
                  </span>
                </div>
              </div>
            </template>
            <div
              v-if="data.profile.remoteWorking"
              class="tw-flex tw-justify-between md:tw-justify-start"
            >
              <span class="tw-w-1/3 md:tw-w-36 lg:tw-w-48 tw-flex-shrink-0">Remote Working</span>
              <span class="tw-w-1/2 md:tw-w-auto tw-font-bold tw-flex-grow">{{ data.profile.remoteWorking }}</span>
            </div>
            <div
              v-if="data.profile.travelFrequency"
              class="tw-flex tw-justify-between md:tw-justify-start"
            >
              <span class="tw-w-1/3 md:tw-w-36 lg:tw-w-48 tw-flex-shrink-0">Travel Frequency</span>
              <span class="tw-w-1/2 md:tw-w-auto tw-font-bold tw-flex-grow">{{ data.profile.travelFrequency }}</span>
            </div>
            <div
              v-if="data.profile.lifestyle"
              class="tw-flex tw-justify-between md:tw-justify-start"
            >
              <span class="tw-w-1/3 md:tw-w-36 lg:tw-w-48 tw-flex-shrink-0">Lifestyle</span>
              <span class="tw-w-1/2 md:tw-w-auto tw-font-bold tw-flex-grow">{{ data.profile.lifestyle }}</span>
            </div>
          </div>
        </div>

        <template v-if="!isOwnProfile">
          <div
            class="profile-nav-button tw-absolute tw-left-0 tw-bottom-0 tw--mb-12"
            @click="prev"
          >
            <i class="fas fa-chevron-left" />
          </div>
          <div
            class="profile-nav-button tw-absolute tw-right-0 tw-bottom-0 tw--mb-12"
            @click="next"
          >
            <i class="fas fa-chevron-right" />
          </div>
        </template>

        <template v-if="isOwnProfile">
          <div class="edit-profile-btn">
            <router-link
              class="btn btn-lg btn-white tw-whitespace-no-wrap"
              to="/profile/edit"
            >
              Edit Profile
            </router-link>
          </div>
        </template>
      </div>
    </div>
    <div class="profile-content md:tw-mt-10 tw-text-sm lg:tw-text-sm">
      <div class="ns-container tw-flex tw-flex-col md:tw-flex-row tw-mb-32">
        <div class="profile-intro-text md:tw-w-7/12 tw-pr-4">
          <template v-if="favouriteQuote.length > 0">
            <div
              class="profile-intro-quote tw-text-lg tw-italic tw-mb-5"
              v-text="favouriteQuote"
            />
          </template>

          <template v-if="bio.length > 0">
            <h3 class="profile-h3">
              About {{ data.profile.nickname }}
            </h3>
            <p
              class="tw-font-semibold tw-text-sm tw-whitespace-pre-line tw-break-words"
              v-text="bio"
            />
          </template>

          <template v-if="goalsValues.length > 0">
            <h3 class="profile-h3">
              Goals & Values
            </h3>
            <p
              class="tw-font-semibold tw-text-sm tw-whitespace-pre-line tw-break-words"
              v-text="goalsValues"
            />
          </template>

          <div
            v-for="i in Object.keys(questions).length"
            :key="`question-${i}`"
          >
            <template v-if="data.profile[`q${i}`].length > 0">
              <h3
                class="profile-h3"
                v-text="questions[i]"
              />
              <p
                class="tw-font-semibold tw-text-sm tw-whitespace-pre-line tw-break-words"
                v-text="data.profile[`q${i}`]"
              />
            </template>
          </div>
        </div>

        <div class="tw-flex tw-self-start md:tw-flex-wrap md:tw-w-5/12 tw-order-first md:tw-order-none tw--mx-4 sm:tw--mx-6 md:tw-mx-0 tw-mb-8 md:tw-mb-0">
          <gallery
            :images="data.images.map((image) => `${$api}${image.imageUrl}`)"
            :index="imageIndex"
            @close="imageIndex = null"
          />
          <div
            v-for="(image, imgIndex) in data.images"
            :key="imgIndex"
            class="tw-w-1/2 lg:tw-w-1/3 tw-flex tw-relative"
            @click="imageIndex = imgIndex"
          >
            <img
              class="profile-gallery-image tw-relative"
              :src="`${$api}${image.thumbUrl}`"
            >
            <div class="profile-gallery-item-mask" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import profileFields from '@/mixins/profile-fields';

export default {
  components: {
    gallery: () => import('vue-gallery'),
    ProfileButtons: () => import('@/components/_vue/ProfileButtons'),
  },

  mixins: [
    profileFields, //
  ],

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    mode: {
      type: String,
      default: () => 'normal',
    },
    index: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      imageIndex: null,
      gallery: null,
      galleryLoaded: false,
      hotkeysLoaded: false,
    };
  },

  computed: {
    isOwnProfile() {
      return this.$route.name === 'profile-view';
    },
  },

  watch: {
    $route() {
      if (['profile', 'profile-view', 'profile-edit', 'profile-backer'].includes(this.$route.name)) {
        this.setMeta();
        this.displayInvitation();
      }
    },
  },

  mounted() {
    console.log('ProfileDesktop.profile', this.data);

    this.setMeta();
    this.displayInvitation();
  },

  // beforeDestroy() {
  //   $('.parallax-slider').attr('src', '');
  // },

  methods: {
    prev() {
      Bus.$emit('profile:previous');
    },

    next() {
      Bus.$emit('profile:next');
    },

    // loadParallax() {
    // if (0) {
    //   const randomCover =
    //     /img/covers/christmas/cover-christmas-${
    //       (`0${Math.floor(Math.random() * 20) + 1}`).slice(-2)
    //     }.jpg`;
    //   $('.profile-detail').parallax({
    //     imageSrc: randomCover,
    //   });
    //   $('.parallax-slider').attr('src', randomCover);
    // }
    // },

    setMeta() {
      // console.log(this.data);
      const meta = {
        title: `${this.data.profile.nickname}`,
      };
      this.$store.dispatch('meta/updateMeta', meta);
    },

    displayInvitation() {
      // if icebreaker received, trigger the popup on load
      if (this.data.inviteReceived) {
        setTimeout(() => {
          $('.accept-invite-btn')[0].click();
        }, 500);
      }
    },

    refreshLocation() {
      Bus.$emit('coordinates:get');
      Bus.$emit('user:v-notify', {
        group: 'transient-notifications',
        type: 'warning',
        title: 'Updating location...',
      });
    },
  },
};
</script>

<style>
.profile.btn-circle,
.profile.btn-circle:hover {
  @apply tw-text-custom-teal tw-bg-white;
}
/* } */

.profile.btn-circle {
  @apply tw-shadow tw-mx-1;
}
.profile.btn-circle:hover {
  @apply tw-shadow-xl;
}

.profile-h3 {
  @apply tw-mt-8 tw-mb-2 tw-text-xl tw-font-bold;
}

.profile-gallery-image,
.profile-gallery-item-mask {
  @apply tw-rounded-lg tw-overflow-hidden tw-m-1;
}

.profile-gallery-item-mask {
  @apply opacity-0 cursor-pointer tw-z-10 tw-bg-gradient2-lr tw-absolute tw-inset-0;
  transition: opacity 400ms linear;
}

.profile-gallery-item-mask:hover {
  @apply opacity-75;
}

.profile-intro-text p {
  @apply mb-5;
}

.profile-nav-button {
  @apply tw-block tw-h-10 tw-w-10 tw-border tw-rounded-lg tw-text-lg tw-text-white tw-flex tw-items-center tw-justify-center tw-cursor-pointer;
  border-color: rgba(5, 223, 215, 0.3);
  transition: all 200ms linear;
}

.profile-nav-button:hover {
  background: #05dfd7;
  border-color: #05dfd7;
}

.profile-nav-button:active {
  @apply tw-text-custom-darkgray;
}

.last-online-icon {
  color: #00d280;
  font-size: 28px;
}

.edit-profile-btn .btn {
  position: absolute;
  right: 0;
  bottom: -50px;
}
</style>
